<template>
    <v-container fluid>

        <v-row justify="center" class="mt-6">
            <span class="fontStyle">選擇廠商：</span>
            <v-text-field v-model="search_text" single-line="" class="input_600 ml-3" placeholder="搜尋" append-icon="mdi-magnify" outlined></v-text-field>
            <v-btn @click="check_point()" large color="primary" class="ml-3 mt-1" style="height: 46px; font-size: 18px;" >查看剩餘點數</v-btn>
            <v-btn @click="deposit_point()" large color="primary" class="ml-3 mt-1" style="height: 46px; font-size: 18px;" >匯入點數</v-btn>
        </v-row>

        <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-data-table :headers="headers" :items="table_data" :search="search_text" class="elevation-1">
                    <template v-slot:item.id="{ item }">
                        {{table_data.findIndex(items => { return items.title == item.title})+1}}
                    </template>
                    <template v-slot:item.set="{item}">
                        <v-btn class="ml-3" color="primary" @click="remaining_point(item)" >查看點數</v-btn>
                        <v-btn class="ml-3" color="success" @click="view_point(item)" :disabled="item.check_bind == true" >選擇</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="remaining_point_dialog" persistent width="500" scrollable>
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>{{linePointData.name}}點數剩餘數量
                    <v-spacer/>
                    <v-icon @click="remaining_point_dialog=false">mdi-close</v-icon></v-card-title>
                <v-card-text class="mt-6">
                    <v-row justify="start" align="start">
                        <p style="white-space: pre-wrap;">面額: {{ linePointData.denomination}}</p>
                    </v-row>
                </v-card-text>
                <v-card-text class="mt-6">
                    <v-row justify="start" align="start">
                        <p style="white-space: pre-wrap;">預定總發送張數: {{ linePointData.totalNumber}}</p>
                    </v-row>
                </v-card-text>
                <v-card-text class="mt-6">
                    <v-row justify="start" align="start">
                        <p style="white-space: pre-wrap;">剩餘張數: {{ linePointData.remaining}}</p>
                    </v-row>
                </v-card-text>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn id='check321' color="success" @click="remaining_point_dialog=false">我知道了</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import bus from '../nav/bus'

var host_url = process.env.VUE_APP_HOST_URL 
export default {
    data(){
        return {
            type_: "",
            search_text: "",
            page: 0,
            vendor_dialog: false,
            vendor_dialog_title: "",
            
            remaining_point_dialog: false,

            headers: [
                {text: '編號', align: 'center', value: 'id', width: 60, sortable: false},
                {text: '問卷名稱', align: 'center', value: 'title', width: 120},
                {text: '建立時間', align: 'center', value: 'created_at', width: 120},
                {text: '所屬廠商', align: 'center', value: 'vendor_name', width: 80, sortable: false},
                {text: '所屬醫師', align: 'center', value: 'doctor_name', width: 80, sortable: false},
                {text: '發出數量', align: 'center', value: 'send_num', width: 80, sortable: false},
                {text: '完成數量', align: 'center', value: 'success_num', width: 80, sortable: false},
                {text: '操作', align: 'center', value: 'set', width: 60, sortable: false},
            ],
            table_data: [],
            linePointData: {
                name: '',
                denomination: 0,
                totalNumber: 0,
                remaining: 0,
            },
            vendor_id: parseInt(localStorage.getItem('vendor_id')),
        }
    },
    created(){
        this.get_account_survey_list()
    },
    methods: {
        UTC2ToLocal(date) {
            date = new Date(date)
            var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
            var offset = date.getTimezoneOffset() / 60;
            var hours = date.getHours();
            newDate.setHours(hours - offset);

            if(newDate.getMinutes()<10 && newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getMinutes()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":"+newDate.getMinutes()
            else
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":"+newDate.getMinutes()

            return newDate
        },
        get_account_survey_list(){
            axios.post(host_url+'get_account_survey_list/')
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.table_data
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                    this.$router.push('/question_overview')
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
        check_point(){
            this.$router.push('/line_point_check')
        },
        deposit_point(){
            this.$router.push('/line_point_deposit')
        },
        view_point(item){
            console.log(item)
            localStorage.setItem('linePointData',  JSON.stringify(item))
            this.$router.push('/line_point_view')
        },
        remaining_point(item){
            this.linePointData.name = item.survey_name
            axios.post(host_url+'get_point_view/', item)
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.linePointData.denomination = tmp.data.denomination
                    this.linePointData.totalNumber = tmp.data.total_number
                    this.linePointData.remaining = tmp.data.remaining
                }
                else{
                    
                }
            })
            .catch((error) => {
                console.log(error)
            })
            this.remaining_point_dialog = true
        }
    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_200{
    max-width: 200px;
}

::v-deep .input_600{
    max-width: 600px;
}
.fontStyle{
    margin-left: 12px;
    line-height: 3.5;
}

</style>